import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { useState, useEffect } from 'react';
import { MaskMixin } from '../../facades';
import { TextInput } from '../../facades';
import maskObject from './masks';
import styled from 'styled-components';
var MaskedStyledInput = MaskMixin(function (_a) {
    var inputRef = _a.inputRef, props = __rest(_a, ["inputRef"]);
    return (React.createElement(TextInput, __assign({ helperText: "", labelText: "", ref: inputRef, id: props.id }, props)));
});
export var MaskedInput = function (_a) {
    var inputType = _a.inputType, valueMax = _a.valueMax, unmask = _a.unmask, onUpdate = _a.onUpdate, labelText = _a.labelText, helperText = _a.helperText, containerClass = _a.containerClass, inputClass = _a.inputClass, props = __rest(_a, ["inputType", "valueMax", "unmask", "onUpdate", "labelText", "helperText", "containerClass", "inputClass"]);
    var _b = useState(false), isInvalid = _b[0], setInvalid = _b[1];
    var _c = useState(false), isComplete = _c[0], setComplete = _c[1];
    var _d = useState(true), isLazy = _d[0], setLazy = _d[1];
    var _e = useState(), maskedRef = _e[0], setMaskedRef = _e[1];
    var _f = useState(''), inputValue = _f[0], setValue = _f[1];
    var requiredClass = props.required ? ' required' : '';
    var disabledClass = props.disabled ? ' disabled' : '';
    var invalidClass = isInvalid ? ' invalid' : '';
    var containerClasses = containerClass || '';
    var inputClasses = inputClass || '';
    var onInputUpdate = function (value, mask) {
        setMaskedRef(mask.el.input);
        var submitValue = unmask ? mask.unmaskedValue : mask.value;
        onUpdate(submitValue);
        setValue(submitValue);
    };
    var onBlur = function () {
        setComplete(true);
        setLazy(true);
    };
    var resetValidation = function () {
        if (maskedRef !== undefined) {
            maskedRef.setCustomValidity('');
        }
        ;
        setInvalid(false);
        setComplete(false);
    };
    var validateField = function () {
        if (maskedRef !== undefined) {
            var regexMasked = new RegExp(maskObject[inputType].pattern, "g");
            var regexUnMasked = new RegExp(maskObject[inputType].um_pattern, "g");
            var regex = unmask ? regexUnMasked : regexMasked;
            if (props.required || inputValue !== '') {
                if (!inputValue.match(regex)) {
                    maskedRef.setCustomValidity("Please match the format " + props.placeholder);
                    setInvalid(true);
                }
            }
        }
    };
    useEffect(function () { validateField(); }, [isComplete]);
    useEffect(function () { resetValidation(); }, [inputValue]);
    return (React.createElement(TextInputContainer, { className: "" + containerClasses + disabledClass + requiredClass },
        React.createElement(MaskedStyledInput, __assign({ blocks: {
                currency: {
                    mask: Number,
                    signed: true,
                    scale: 2,
                    thousandsSeparator: ',',
                    radix: '.',
                    max: valueMax
                },
                decimal: {
                    mask: Number,
                    signed: true,
                    scale: 2,
                    radix: '.',
                    max: valueMax
                },
                integer: {
                    mask: Number,
                    signed: true,
                    scale: 0,
                    max: valueMax
                }
            }, mask: maskObject[inputType].mask, className: "AD_textInput py-2 px-3" + invalidClass + " " + inputClasses + disabledClass + requiredClass, "data-lpignore": "true", unmask: unmask, lazy: isLazy, type: maskObject[inputType].type, mode: maskObject[inputType].mode, maxLength: 255, onAccept: function (value, mask) { return onInputUpdate(value, mask); }, onBlur: function () { return onBlur(); }, onInvalidCapture: function () { return setInvalid(true); }, onInput: function () { setLazy(false); isInvalid && setInvalid(false); }, helperText: helperText, labelText: labelText }, props))));
};
export default MaskedInput;
MaskedInput.default = {
    unmask: true,
    type: 'text',
    lazy: true,
    id: "_ " + Math.random().toString(36).substr(2, 9)
};
var TextInputContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
//# sourceMappingURL=MaskedInput.js.map